/*
document.addEventListener('cart:refresh', (e) => {
  console.log('cart:refresh', e);
});
window.addEventListener('pageshow', async (e) => {
  console.log('pageshow', e);
});
*/

window.addEventListener('pageshow', async (e) => {
  // console.log('pageshow', e);

  // Add quick add button to product card
  const productCards = document.querySelectorAll('.product-card');
  // console.log('productCards', productCards);
  productCards.forEach((productCard) => {
    if(productCard.querySelector('.product-card-add-button')){
      productCard.querySelector('.product-card-add-button').addEventListener('click', async (e) => {
        // console.log('productCard', productCard);
        e.preventDefault();

        setTimeout(() => {
          // console.log(productCard.querySelector('.product-card__quick-add-button'));
          productCard.querySelector('.product-card__quick-add-button').click();
        }, 200);
      });
    }
  });

  // Check if cart is empty
  const cartItems = document.querySelectorAll('.shopify-section--main-cart .order-summary .line-item');
  if (cartItems && cartItems.length > 0) {
    await cartUpdatePant(cartItems, true);
  }
});

// Update pant values on cart change
document.addEventListener('cart:change', async (e) => {
  // console.log('cart:change', e);
  // console.log('cart:items', e.detail.cart.items);
  // console.log('sections', e.detail.cart.sections);

  let cartItems = null;
  Object.keys(e.detail.cart.sections).forEach((section) => {
    const sectionHtml = e.detail.cart.sections[section];
    if (sectionHtml) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      cartItems = doc.querySelectorAll('.cart-drawer__items .line-item');
    }
  });

  if (cartItems && cartItems.length > 0) {
    await cartUpdatePant(cartItems);
  }
});

async function cartUpdatePant(items, reload = false) {
  const pantTypes = ['a', 'b', 'c'];
  const pantVariantIds = {
    a: 48232119796049,
    b: 48232119828817,
    c: 48232119861585
  };

  // Update products quantity
  let updates = {};

  // Add normalt quantity
  items.forEach((item) => {
    const isPant = item.getAttribute('data-pant');
    const variantId = parseInt(item.getAttribute('data-variant-id'));
    const quantity = parseInt(item.getAttribute('data-quantity'));

    // Only update if not pant product
    if (!isPant) {
      updates[variantId] = quantity;
    }
  });

  // Update pant quantity
  items.forEach((item) => {
    const isPant = item.getAttribute('data-pant');
    const variantId = parseInt(item.getAttribute('data-variant-id'));
    const quantity = parseInt(item.getAttribute('data-quantity'));

    // Only update if not pant product
    if (isPant && !updates[variantId]) {
      updates[variantId] = 0;
    } else {
      pantTypes.forEach(type => {
        const pantQuantity = item.getAttribute('data-pant-' + type);
        if (pantQuantity) {
          const pantId = pantVariantIds[type];
          if(!updates[pantId]) {
            updates[pantId] = 0;
          }

          updates[pantId] += parseInt(pantQuantity) * quantity;
        }
      });
    }
  });

  // Remove pant quantity if quantity is same
  items.forEach((item) => {
    const pant = item.getAttribute('data-pant');
    const pantVariantId = parseInt(item.getAttribute('data-variant-id'));
    if (pant && pantVariantId) {
      const quantity = parseInt(item.getAttribute('data-quantity'));
      if (quantity === updates[pantVariantId]) {
        delete updates[pantVariantId];
      }
    }
  });

  // Check if updates is empty
  if (Object.keys(updates).length === 0) {
    return;
  }

  // Update cart
  try {
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({updates})
    });

    if (reload) {
      // location.reload();
      window.location.replace('/');
    } else {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }, 200);
    }
  } catch (error) {
    console.error('Error:', error);
  }
}